import React, { lazy } from 'react';
import { useSelector } from 'react-redux';
import RouterRoutes from 'Helpers/routes/router-routes';
import { registry } from 'Store';
import { GetDashboardAndRouteToNextStep } from 'Components/dashboard/ducks/actions';
import { getDashboardSteps } from 'Components/dashboard/ducks/selectors';

const IdentityComponent = lazy(() =>
  import(
    /* webpackChunkName: "carvana-purchase-identity" */ '@carvana/purchase-identity'
  )
);

export const IdentityRoute = props => {
  const steps = useSelector(getDashboardSteps);

  return (
    <RouterRoutes
      {...props}
      lazyLoadingText="Loading Identity Verification"
      isLoadingText="Getting Identity Verification Status"
    >
      <IdentityComponent
        registry={registry}
        dashboardActions={{
          GetDashboardAndRouteToNextStep
        }}
        steps={steps}
      />
    </RouterRoutes>
  );
};
